import { render, staticRenderFns } from "./DeleteEmailCampaignDialog.vue?vue&type=template&id=722eb2ab"
import script from "./DeleteEmailCampaignDialog.vue?vue&type=script&lang=js"
export * from "./DeleteEmailCampaignDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports